var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDiamond = function SvgIconDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.695 13.237a1.75 1.75 0 0 1 0-2.474L10.757 1.7a1.75 1.75 0 0 1 2.475 0l9.065 9.064a1.75 1.75 0 0 1 0 2.475l-9.062 9.062a1.75 1.75 0 0 1-2.475 0zM3.286 12l8.711 8.711 8.709-8.708-8.711-8.711z",
    clipRule: "evenodd"
  })));
};
export default SvgIconDiamond;